// Single source of truth for client-side email validation so every form
// accepts and rejects the same addresses.
const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i

export default EMAIL_PATTERN
